import { size, truncate } from 'lodash/fp';
import { UnicodeEntity } from '@mews/enums';

interface Props {
    text: string;
    shortText?: string;
    maxLength?: number;
}

const DEFAULT_TEXT_LENGTH = 15;

const TruncatedText: React.FC<Props> = ({ text, shortText, maxLength = DEFAULT_TEXT_LENGTH }) => {
    const truncatedText =
        size(text) > maxLength
            ? truncate({ length: maxLength, omission: UnicodeEntity.Ellipsis }, shortText || text)
            : text;

    return <span>{truncatedText}</span>;
};

export default TruncatedText;
